import { FC } from 'react';

import useProductById from 'src/hooks/swr/useProductById';

const ProductName: FC<{ productId: string }> = ({ productId }) => {
  const { product, productLoading } = useProductById(productId);

  if (productLoading) {
    return <div>isLoading</div>;
  }

  return <span>{product?.fullName ?? ''}</span>;
};

export default ProductName;
